import Vue from "vue"
import Router from "vue-router"
import Meta from 'vue-meta'

import AppHeader from "./layout/AppHeader"
import AppFooter from "./layout/AppFooter"
import DefaultLayout from "./views/layouts/DefaultLayout.vue"

// import Components from "./views/examples/Components.vue";
// import Landing from "./views/examples/Landing.vue";
// import Login from "./views/examples/Login.vue";
// import Register from "./views/examples/Register.vue";
// import Profile from "./views/examples/Profile.vue";

import Index from "./views/Index.vue"
import Search from "./views/Search.vue"
import Introduction from "./views/Introduction.vue"
import Founder from "./views/founder/Founder.vue"
import Chairman from "./views/Chairman.vue"
import Library from "./views/Library.vue"
import ContactInformation from "./views/ContactInformation.vue"
import TrafficInformation from "./views/TrafficInformation.vue"
import SupportDonation from "./views/SupportDonation.vue"
import FinancialDisclosures from "./views/FinancialDisclosures.vue"
import Recruitments from "./views/recruitment/Recruitments.vue"

import Bulletins from "./views/publication/Bulletins.vue"
import Bulletin from "./views/publication/Bulletin.vue"
import CourseCancelBulletin from "./views/publication/CourseCancelBulletin.vue"
import Sidelights from "./views/publication/Sidelights.vue"
import Sidelight from "./views/publication/Sidelight.vue"
import Weeklies from "./views/publication/Weeklies.vue"
import Monthlies from "./views/publication/Monthlies.vue"

import TodayCourses from "./views/course/TodayCourses.vue"
import AllCourses from "./views/course/AllCourses.vue"
import CourseReview from "./views/course/CourseReview.vue"
import Course from "./views/course/Course.vue"
import Lecturer from "./views/course/Lecturer.vue"

import College from "./views/college/College.vue";
import Department from "./views/college/Department.vue";
import CollegeRegistration from "./views/college/CollegeRegistration.vue";

import HwadzanGardenIntro from "./views/HwadzanGardenIntro.vue"
import EventReview from "./views/event/EventReview.vue"
import LatestEvents from "./views/event/LatestEvents.vue"
import Event from "./views/event/Event.vue"
import EventLiveStreaming from "./views/event/EventLiveStreaming.vue"
import EventRegistrationInfo from "./views/event/EventRegistrationInfo.vue"
import EventRegistrationForm from "./views/event/EventRegistrationForm.vue"

import BooksSearch from "./views/dharma/BooksSearch.vue"
import Books from "./views/dharma/Books.vue"
import LendableBooks from "./views/dharma/LendableBooks.vue"
import PicturesSearch from "./views/dharma/PicturesSearch.vue"
import Pictures from "./views/dharma/Pictures.vue"
import Dharmas from "./views/dharma/Dharmas.vue"
import DharmasSearch from "./views/dharma/DharmasSearch.vue"
import Book from "./views/dharma/Book.vue"
import Picture from "./views/dharma/Picture.vue"

import AllLiveStreamingSeries from "./views/audiovisual/AllLiveStreamingSeries.vue"
import LiveStreamingSeries from "./views/audiovisual/LiveStreamingSeries.vue"
import RecentlyAddedSeries from "./views/audiovisual/RecentlyAddedSeries.vue"
import UpdatedSeries from "./views/audiovisual/UpdatedSeries.vue"
import OngoingSeries from "./views/audiovisual/OngoingSeries.vue"
import ClassifiedSeries from "./views/audiovisual/ClassifiedSeries.vue"
import SeriesSearch from "./views/audiovisual/SeriesSearch.vue"
import Series from "./views/audiovisual/Series.vue"

import BuddhistDictionaryTool from "./views/BuddhistDictionaryTool.vue"
import BuddhaEducationalAnimation from "./views/BuddhaEducationalAnimation.vue"

import Articles from "./views/love-life/Articles.vue";
import Resources from "./views/love-life/Resources.vue";

import Amtb from "./views/Amtb.vue"
import OtherWebsite from "./views/OtherWebsite.vue"
import Test from "./views/Test.vue"

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  linkExactActiveClass: 'active',
  mode: 'history',
  base: process.env.VUE_APP_BASE_PATH || '/',
  routes: [
    {
      path: '/',
      name: 'index',
      components: {
        header: AppHeader,
        default: Index,
        footer: AppFooter
      }
    },
    {
      path: '/introduction',
      name: 'introduction',
      components: {
        header: AppHeader,
        default: Introduction,
        footer: AppFooter
      }
    },
    {
      path: '/founder',
      name: 'founder',
      components: {
        header: AppHeader,
        default: Founder,
        footer: AppFooter
      }
    },
    {
      path: '/chairman',
      name: 'chairman',
      components: {
        header: AppHeader,
        default: Chairman,
        footer: AppFooter
      }
    },
    {
      path: '/library',
      name: 'library',
      components: {
        header: AppHeader,
        default: Library,
        footer: AppFooter
      }
    },
    {
      path: '/contact-information',
      name: 'contact-information',
      components: {
        header: AppHeader,
        default: ContactInformation,
        footer: AppFooter
      }
    },
    {
      path: '/traffic-information',
      name: 'traffic',
      components: {
        header: AppHeader,
        default: TrafficInformation,
        footer: AppFooter
      }
    },
    {
      path: '/support-donation',
      name: 'support-donation',
      components: {
        header: AppHeader,
        default: SupportDonation,
        footer: AppFooter
      }
    },
    {
      path: '/recruitments',
      name: 'recruitments',
      components: {
        header: AppHeader,
        default: Recruitments,
        footer: AppFooter
      }
    },
    {
      path: '/financial-disclosures',
      name: 'financial-disclosures',
      components: {
        header: AppHeader,
        default: FinancialDisclosures,
        footer: AppFooter
      }
    },
    {
      path: '/bulletins',
      components: {
        header: AppHeader,
        default: DefaultLayout,
        footer: AppFooter
      },
      children: [
        {
          path: '',
          name: 'bulletins',
          component: Bulletins,
        },
        {
          path: 'course-cancel',
          name: 'course-cancel-bulletin',
          component: CourseCancelBulletin,
        },
        {
          path: ':id(\\d+)',
          name: 'bulletin',
          component: Bulletin,
          props: true
        }
      ],
    },
    {
      path: '/sidelights',
      components: {
        header: AppHeader,
        default: DefaultLayout,
        footer: AppFooter
      },
      children: [
        {
          path: '',
          name: 'sidelights',
          component: Sidelights,
        },
        {
          path: ':id(\\d+)',
          name: 'sidelight',
          component: Sidelight,
          props: true
        }
      ],
    },
    {
      path: '/weeklies',
      components: {
        header: AppHeader,
        default: DefaultLayout,
        footer: AppFooter
      },
      children: [
        {
          path: '',
          name: 'weeklies',
          component: Weeklies,
        }
      ],
    },
    {
      path: '/monthlies',
      components: {
        header: AppHeader,
        default: DefaultLayout,
        footer: AppFooter
      },
      children: [
        {
          path: '',
          name: 'monthlies',
          component: Monthlies,
        }
      ],
    },
    {
      path: '/courses',
      components: {
        header: AppHeader,
        default: DefaultLayout,
        footer: AppFooter
      },
      children: [
        {
          path: 'today',
          name: 'today-courses',
          component: TodayCourses
        },
        {
          path: 'all',
          name: 'all-courses',
          component: AllCourses
        },
        {
          path: 'review',
          name: 'course-review',
          component: CourseReview
        },
        {
          path: ':id(\\d+)',
          name: 'course',
          component: Course,
          props: true
        }
      ],
    },
    {
      path: '/lecturers',
      components: {
        header: AppHeader,
        default: DefaultLayout,
        footer: AppFooter
      },
      children: [
        {
          path: ':id(\\d+)',
          name: 'lecturer',
          component: Lecturer,
          props: true
        }
      ],
    },
    {
      path: '/colleges',
      components: {
        header: AppHeader,
        default: DefaultLayout,
        footer: AppFooter
      },
      children: [
        {
          path: 'latest-session',
          name: 'latest-session-in-colleges',
          component: College,
        },
        {
          path: ':id(\\d+)',
          name: 'college',
          component: College,
          props: true
        },
        {
          path: ':id(\\d+)/registration',
          name: 'college-registration',
          component: CollegeRegistration,
          props: true
        }
      ],
    },
    {
      path: '/departments',
      components: {
        header: AppHeader,
        default: DefaultLayout,
        footer: AppFooter
      },
      children: [
        {
          path: ':id',
          name: 'department',
          component: Department,
          props: true
        },
      ],
    },
    {
      path: '/events',
      components: {
        header: AppHeader,
        default: DefaultLayout,
        footer: AppFooter
      },
      children: [
        {
          path: 'latest',
          name: 'latest-events',
          component: LatestEvents,
        },
        {
          path: 'review',
          name: 'event-review',
          component: EventReview,
        },
        {
          path: ':id(\\d+)',
          component: DefaultLayout,
          children: [
            {
              path: '',
              name: 'event',
              component: Event,
              props: true
            },
            {
              path: 'live-streaming',
              name: 'event-live-streaming',
              component: EventLiveStreaming,
              props: true
            },
            {
              path: 'registration-info',
              name: 'event-registration-info',
              component: EventRegistrationInfo,
              props: true
            },
            {
              path: 'registration-form',
              name: 'event-registration-form',
              component: EventRegistrationForm,
              props: true
            }
          ]
        }
      ],
    },
    {
      path: '/hwadzan-garden',
      components: {
        header: AppHeader,
        default: DefaultLayout,
        footer: AppFooter
      },
      children: [
        {
          path: 'intro',
          name: 'hwadzan-garden-intro',
          component: HwadzanGardenIntro,
        }
      ],
    },
    {
      path: '/books',
      components: {
        header: AppHeader,
        default: DefaultLayout,
        footer: AppFooter
      },
      props: {
        header: { show_application_list_entry: true }
      },
      children: [
        {
          path: 'search',
          name: 'books-search',
          component: BooksSearch
        },
        {
          path: ':group([a-z]+)/:language([a-z]+)',
          name: 'books',
          component: Books,
          props: route => {
            return {
              group: route.params.group,
              language: route.params.language
            }
          }
        },
        {
          path: ':id(\\d+)',
          name: 'book',
          component: Book,
          props: true
        }
      ],
    },
    {
      path: '/lendable-books',
      name: 'lendable-books',
      components: {
        header: AppHeader,
        default: LendableBooks,
        footer: AppFooter
      }
    },
    {
      path: '/pictures',
      components: {
        header: AppHeader,
        default: DefaultLayout,
        footer: AppFooter
      },
      props: {
        header: { show_application_list_entry: true }
      },
      children: [
        {
          path: 'search',
          name: 'pictures-search',
          component: PicturesSearch
        },
        {
          path: ':group([a-z]+)',
          name: 'pictures',
          component: Pictures,
          props: route => {
            return {
              group: route.params.group
            }
          }
        },
        {
          path: ':id(\\d+)',
          name: 'picture',
          component: Picture,
          props: true
        }
      ],
    },
    {
      path: '/dharmas',
      components: {
        header: AppHeader,
        default: DefaultLayout,
        footer: AppFooter
      },
      props: {
        header: { show_application_list_entry: true }
      },
      children: [
        {
          path: ':group([a-z]+)/:type([a-z]+)',
          name: 'dharmas',
          component: Dharmas,
          props: route => {
            return {
              group: route.params.group,
              type: route.params.type,
              language: route.query.language
            }
          }
        },
        {
          path: 'search',
          name: 'dharmas-search',
          component: DharmasSearch
        }
      ],
    },
    {
      path: '/series',
      components: {
        header: AppHeader,
        default: DefaultLayout,
        footer: AppFooter
      },
      children: [
        {
          path: 'live-streaming',
          name: 'live-streaming-series',
          component: LiveStreamingSeries
        },
        {
          path: 'live-streaming/all',
          name: 'all-live-streaming-series',
          component: AllLiveStreamingSeries
        },
        {
          path: 'ongoing',
          name: 'ongoing-series',
          component: OngoingSeries
        },
        {
          path: 'recently-added',
          name: 'recently-added-series',
          component: RecentlyAddedSeries
        },
        {
          path: 'updated',
          name: 'updated-series',
          component: UpdatedSeries
        },
        {
          path: 'classified',
          name: 'classified-series',
          component: ClassifiedSeries,
          props: route => {
            return {
              category_no: route.query.category_no
            }
          }
        },
        {
          path: 'search',
          name: 'series-search',
          component: SeriesSearch
        },
        {
          path: ':series_no(\\w+)',
          name: 'series',
          component: Series,
          props: true
        }
      ],
    },
    {
      path: '/buddhist-dictionary-tool',
      name: 'buddhist-dictionary-tool',
      components: {
        header: AppHeader,
        default: BuddhistDictionaryTool,
        footer: AppFooter
      }
    },
    {
      path: '/buddha-educational-animation',
      name: 'buddha-educational-animation',
      components: {
        header: AppHeader,
        default: BuddhaEducationalAnimation,
        footer: AppFooter
      }
    },
    {
      path: '/love-life',
      components: {
        header: AppHeader,
        default: DefaultLayout,
        footer: AppFooter
      },
      children: [
        {
          path: 'articles/:type([a-z\-]+)?',
          name: 'love-life-articles',
          component: Articles,
          props: route => {
            return {
              type: route.params.type,
            }
          }
        },
        {
          path: 'resources/:type([a-z\-]+)?',
          name: 'love-life-resources',
          component: Resources,
          props: route => {
            return {
              type: route.params.type,
            }
          }
        }
      ],
    },
    {
      path: '/search/:type([a-z]+)?',
      name: 'search',
      components: {
        header: AppHeader,
        default: Search,
        footer: AppFooter
      }
    },
    {
      path: '/amtb',
      name: 'amtb',
      components: {
        header: AppHeader,
        default: Amtb,
        footer: AppFooter
      }
    },
    {
      path: '/other-website',
      name: 'other-website',
      components: {
        header: AppHeader,
        default: OtherWebsite,
        footer: AppFooter
      }
    },
    {
      path: '/test',
      name: 'test',
      components: {
        header: AppHeader,
        default: Test,
        footer: AppFooter
      }
    },
    {
      path: '*', // 使用萬用字元 '*' 匹配所有未定義的路徑
      redirect: '/' // 重新導向到首頁
    },
    // {
    //   path: "/login",
    //   name: "login",
    //   components: {
    //     header: AppHeader,
    //     default: Login,
    //     footer: AppFooter
    //   }
    // },
    // {
    //   path: "/register",
    //   name: "register",
    //   components: {
    //     header: AppHeader,
    //     default: Register,
    //     footer: AppFooter
    //   }
    // },
    // {
    //   path: "/profile",
    //   name: "profile",
    //   components: {
    //     header: AppHeader,
    //     default: Profile,
    //     footer: AppFooter
    //   }
    // }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});

// 加入 GA4 頁面追蹤
router.afterEach((to) => {
  if (typeof gtag === 'function') {
    gtag('event', 'page_view', {
      page_path: to.fullPath,
    });
  }
});

// 將 router 匯出
export default router;
